import './consignmentPickUp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { authKey, GET_CONSIGNMENT_DETAILS_BY_NUMBER, CONSIGNMENT_SAVE, TRIP_START, CREATE_DELIVERY_CHALLAN, PRINT_DOWNLOAD_DATA, UPLOAD_DCUMENT, DOWNLOAD_DOCUMENT, TOLERANCE } from '../../../common/URLs';

import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from "react-router-dom";
import { Container, Card, CardContent, Divider, Tooltip, IconButton, FormLabel, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import Moment from 'moment';
import { PROD, PIT_ROLES, FILE_NAME_VALIDATION_ERROR, allowedFileTypes } from '../../../common/constants';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import Badge from 'react-bootstrap/Badge';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import jwt from 'jwt-decode';
import { VALIDATION, capitalizeFunction, fileNameValidation, weightValidation } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { AddIcon, ApproveIcon, DownloadIcon, PrintIcon, UpdateIcon, ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ConsignmentPickUp() {

  const decoded = jwt(getLocalStorageItem('id_token'));
  const { state } = useLocation();
  const [invoiceNo, setInvoiceNo] = useState();
  const [characterLimit] = useState(500);
  const navigate = useNavigate();
  const [consignmentdetails, setConsignmentdetails] = useState();
  const [consignmentsource, setConsignmentsource] = useState();
  const [odoMeterReading, setOdoMeterReading] = useState();
  const [consignmentsave, setConsignmentsave] = useState();
  const [saveConsignmentResponse, setSaveConsignmentResponse] = useState();
  const [starttrip, setStarttrip] = useState();
  const [showStarttrip, setShowStarttrip] = useState(true);
  const [consignemntsaveResponse, setConsignemntsaveResponse] = useState();
  const [consignmentNoDetails, setConsignmentNoDetails] = useState({
    "consignmentNo": state?.consignmentNo ? state?.consignmentNo : "",
    "odometerStart": "",
    "comments": "",
  });
  const [pickupUpdatedDetails, setPickupUpdatedDetails] = useState({
    "isProperLashing": null,
    "isPayloadWithinCapacity": null,
    "isPayloadLengthExceedLimit": null,
    "isPayloadHeightExceedLimit": null,
    // "pickupTareWeight": null,
    // "pickupGrossWeight": null
    picupNetWeight: null
  });
  console.log("pickupUpdatedDetails", !pickupUpdatedDetails?.isProperLashing)
  // const pickupNetWeight = pickupUpdatedDetails?.pickupGrossWeight ? Number((pickupUpdatedDetails?.pickupGrossWeight) - (pickupUpdatedDetails
  //   ?.pickupTareWeight))?.toFixed(4) : null;
  const [minimum, setMinimum] = useState();
  const [maximum, setMaximum] = useState();
  const [addComment, setAddComment] = useState('');
  const [createDeliveryChallan, setCreateDeliveryChallan] = useState();
  const [downloadDeliveryChallan, setDownloadDeliveryChallan] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const [logModalOpen3, setLogModalOpen3] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => setLogModalOpen2(false);
  const handleLogModalOpen3 = () => setLogModalOpen3(true);
  const handleLogModalClose3 = () => setLogModalOpen3(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [confirmOpen3, setConfirmOpen3] = useState(false);
  const handleConfirmOpen3 = () => setConfirmOpen3(true);
  const handleConfirmClose3 = () => setConfirmOpen3(false);

  const [errorMessage, setErrorMessage] = useState({
    consignmentNoError: "",
    odometerStartError: "",
    vehicleBarcodeError: "",
    lotDetailsError: "",
    "pickupGrossWeightError": "",
    "pickupTareWeightError": "",
    "pickupNetWeightError": "",
  });

  const [urn, setUrn] = useState();
  const [showGrid, setShowGrid] = useState(false);
  const [showRB, setShowRB] = useState(false);
  const [showCB, setShowCB] = useState(false);

  // useEffect(() => {
  //   if (pickupUpdatedDetails?.pickupGrossWeight && pickupUpdatedDetails?.pickupTareWeight) {
  //     toleranceLimit();
  //   }
  // }, [pickupUpdatedDetails?.pickupGrossWeight, pickupUpdatedDetails?.pickupTareWeight]);

  const toleranceLimit = () => {
    loaderService.showLoader();
    apiClient
      .post(
        TOLERANCE,
        {

        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        let tolWeightLimit = 0;
        let avgMoistureLimit = 0;
        response.data.qualityManagedToleranceLimitList?.forEach(tl => {
          if (tl.materialCode === "RawBamboo") {
            if (tl.qualityParameter === "Weight") {
              tolWeightLimit = tl.toleranceLimit;
            }
          }

        })
        let value = (consignmentdetails?.consignmentWeight)
        let tolerance = (value * tolWeightLimit) / 100;
        const minValue = Number(((value - tolerance) * 100) / 100).toFixed(2);
        const maxValue = Number(((value + tolerance) * 100) / 100).toFixed(2);
        // if (pickupNetWeight > maxValue || pickupNetWeight < minValue) {
        //   setErrorMessage({ ...errorMessage, pickupNetWeightError: `Value must be within ${minValue} and ${maxValue} ` });
        // } else {
        //   setErrorMessage({ ...errorMessage, pickupNetWeightError: "" });
        //   setMinimum(minValue);
        //   setMaximum(maxValue);
        // }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  };

  const radioChange = (e, value) => {
    setPickupUpdatedDetails({
      ...pickupUpdatedDetails, [e.target.name]: value,
    })

    if (e.target.name === "isHitInspectionChecklist") {
      setErrorMessage({ ...errorMessage, isHitInspectionChecklistError: "" });
    }
    if (e.target.name === "isProperLashing") {
      setErrorMessage({ ...errorMessage, isProperLashingError: "" });
    }
    if (e.target.name === "isPayloadWithinCapacity") {
      setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "" });
    }
    if (e.target.name === "isPayloadLengthExceedLimit") {
      setErrorMessage({ ...errorMessage, isPayloadLengthExceedLimitError: "" });
    }
    if (e.target.name === "isPayloadHeightExceedLimit") {
      setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "" });
    }

  };

  const onAddBundle = (e) => {
    e.preventDefault();
    setShowGrid(true);
  }
  const onRawbamboo = (e) => {
    e.preventDefault();
    setShowRB(true);
  }
  const onChipedBamboo = (e) => {
    e.preventDefault();
    navigate("/ConsignmentCB");
  }
  const viewUpdatePickup = (e, growerItem) => {
    e.preventDefault();
    const userData = {
      consignmentNo: consignmentNoDetails.consignmentNo,
    };
    navigate("./PickUpDetails", { state: { consignmentdetails: consignmentdetails, growerItem: growerItem } });
  }
  const gotoHarvestingDetails = (e) => {
    e.preventDefault();
    navigate("/HarvestingDetails");
  }

  const handleChange = (e) => {
    if (e.target.name === "consignmentNo") {
      setErrorMessage({ ...errorMessage, consignmentNoError: "" });
      setConsignmentNoDetails({ ...consignmentNoDetails, [e.target.name]: e.target.value.slice(0, 15) });
    }
    if (e.target.name === "odometerStart") {
      setOdoMeterReading(e.target.value.slice(0, 6));
      setErrorMessage({ ...errorMessage, odometerStartError: "" });
    }
    // if (e.target.name === "pickupTareWeight") {
    //   weightValidation(e.target.value) && setPickupUpdatedDetails({ ...pickupUpdatedDetails, [e.target.name]: e.target.value });
    //   setErrorMessage({ ...errorMessage, pickupTareWeightError: "" });
    // }
    // if (e.target.name === "pickupGrossWeight") {
    //   weightValidation(e.target.value) && setPickupUpdatedDetails({ ...pickupUpdatedDetails, [e.target.name]: e.target.value });
    //   setErrorMessage({ ...errorMessage, pickupGrossWeightError: "" });
    // }

  }
  const onTextValueChange = (e) => {
    setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
  }


  const getDetails = (e) => {
    e.preventDefault();
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      getConsignmentDetails();
    }
  }

  useEffect(() => {
    getConsignmentDetails();
  }, [state?.consignmentNo])



  useEffect(() => {
    if (saveConsignmentResponse) {
      if (saveConsignmentResponse.isSuccess === true) {
        toast.success(saveConsignmentResponse?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(saveConsignmentResponse?.message ? saveConsignmentResponse?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [saveConsignmentResponse]);


  useEffect(() => {
    if (starttrip) {
      if (starttrip?.isSuccess === true) {
        toast.success(starttrip?.message)
        {
          getLocalStorageItem('id_token') && decoded.extension_URN ?
            navigate('/dashboardHome/dashboardStakeHolder') :
            navigate('/ConsignmentPickUp')
        }
        // handleLogModalOpen1();
      }
      else {
        toast.error(starttrip?.message ? starttrip?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [starttrip]);


  const getConsignmentDetails = () => {

    if (consignmentNoDetails.consignmentNo != "") {
      loaderService.showLoader()
      apiClient
        .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
          {
            "consignmentNumber": consignmentNoDetails.consignmentNo,
          },
          {
            headers: {
              Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null
        )
        .then((response) => {
          //console.log(response.data.consignmentSourceDetails?.[0]?.odometerReading)
          setConsignmentdetails(response.data);
          setConsignmentNoDetails({
            ...consignmentNoDetails,
            // "odometerStart":response.data.odometerReading,
            "odometerStart": response.data.consignmentSourceDetails?.[0]?.odometerReading ? response.data.consignmentSourceDetails?.[0]?.odometerReading : "",
            // "vehicleBarcode":response.data.consignmentBarCode,
            "vehicleBarcode": null,
            // "comments": response.data.comments,
          })
          setOdoMeterReading(response.data.consignmentSourceDetails?.[0]?.odometerReading ? response.data.consignmentSourceDetails?.[0]?.odometerReading : "",)
          setAddComment(response.data.comments);
          setConsignmentsource(response.data.consignmentSourceDetails);
          setPickupUpdatedDetails({
            "isProperLashing": response.data.consignmentSourceDetails?.[0]?.isProperLashing,
            "isPayloadWithinCapacity": response.data.consignmentSourceDetails?.[0]?.isPayloadWithinCapacity,
            "isPayloadLengthExceedLimit": response.data.consignmentSourceDetails?.[0]?.isPayloadLengthExceedLimit,
            "isPayloadHeightExceedLimit": response.data.consignmentSourceDetails?.[0]?.isPayloadHeightExceedLimit,
            // "pickupGrossWeight": response.data.consignmentSourceDetails?.[0]?.pickupGrossWeight,
            // "pickupTareWeight": response.data.consignmentSourceDetails?.[0]?.pickupTareWeight,
            "pickupNetWeight": response.data?.pickupNetWeight
          });
          setInvoiceNo(response.data.consignmentSourceDetails?.[0]?.invoiceNo);
          let Validstatus = ["LoadingCompleted"];
          response.data.consignmentSourceDetails.forEach(source => {
            if (!Validstatus.includes(source.consignmentStatus)) {
              setShowStarttrip(false);
            }
          })
          loaderService.hideLoader()
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader()
          toast.error(error.message);
        });
    }
  }

  const onStart = (e) => {
    //console.log("start trip")
    if (odoMeterReading) {
      startTripToDestination();
    }
    else {
      if (!consignmentNoDetails.consignmentNo) {
        setErrorMessage({ ...errorMessage, consignmentNoError: "Please enter Consignment No" })
      }
      if (consignmentdetails?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs == null) {
        setErrorMessage({ ...errorMessage, lotDetailsError: "Lot details not available" })
      }

    }
  }

  const onSave = (e) => {
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      consignmentSave();
    }
  }

  const consignmentSave = (e) => {

    loaderService.showLoader();
    apiClient
      .post(CONSIGNMENT_SAVE,
        {
          "consignmentNo": consignmentNoDetails.consignmentNo,
          //  "consignmentBarCode": consignmentNoDetails.vehicleBarcode,
          "consignmentBarCode": null,
          "odometerReading": odoMeterReading,
          "comments": addComment,
          "isTripStarted": consignmentdetails.isTripStarted,
          "isLoadingDone": consignmentdetails.isLoadingDone
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSaveConsignmentResponse(response.data);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        setSaveConsignmentResponse(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const startTripToDestination = (e) => {
    loaderService.showLoader()
    apiClient
      .post(TRIP_START,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
          "aggregatedLeftoverQuantity": consignmentNoDetails?.aggregatedLeftoverQuantity,
          "totalWeight": consignmentNoDetails?.totalWeight,
          "totalMoisture": consignmentNoDetails?.totalMoisture,
          "isTripStarted": true,
          "consignmentSaveDetails":
          {
            "consignmentNo": consignmentNoDetails?.consignmentNo,
            "odometerReading": odoMeterReading,
            "comments": addComment,
            "isProperLashing": pickupUpdatedDetails?.isProperLashing,
            "isPayloadWithinCapacity": pickupUpdatedDetails?.isPayloadWithinCapacity,
            "isPayloadLengthExceedLimit": pickupUpdatedDetails?.isPayloadLengthExceedLimit,
            "isPayloadHeightExceedLimit": pickupUpdatedDetails?.isPayloadHeightExceedLimit,
            // "pickupGrossWeight": pickupUpdatedDetails?.pickupGrossWeight,
            "pickupNetWeight": pickupUpdatedDetails?.pickupNetWeight,
            // "pickupTareWeight": pickupUpdatedDetails?.pickupTareWeight
          }
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStarttrip(response.data);
        setShowStarttrip(false);
        getConsignmentDetails();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onDeliveryChallan = (e) => {
    if (!consignmentNoDetails.consignmentNo) {
      setErrorMessage({ ...errorMessage, consignmentNoError: "Please Enter Consignment Number" })
    }
    else {
      toCreateDeliveryChallan();
    }
  }

  const toCreateDeliveryChallan = (e) => {
    loaderService.showLoader();
    apiClient
      .post(CREATE_DELIVERY_CHALLAN,
        {
          "consignmentNo": consignmentNoDetails?.consignmentNo,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setCreateDeliveryChallan(response.data);
        loaderService.hideLoader();
        getConsignmentDetails();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (createDeliveryChallan) {
      if (createDeliveryChallan.isSuccess === true) {
        toast.success(createDeliveryChallan?.message);
        // handleLogModalOpen3();
      }
      else {
        toast.error(createDeliveryChallan?.message ? createDeliveryChallan?.message : "Error");
        // handleLogModalOpen();
      }
    }
  }, [createDeliveryChallan]);

  const getDownloadChallan = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": consignmentdetails?.delieryChallanNumber,
          "printDetailsType": "delivery_challan",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadDeliveryChallan(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  const column = [
    { field: 'scheduleLineNumber', headerName: 'Schedule Line', width: 120 },
    { field: 'sourceStakeholderPo', headerName: 'Grower PO', width: 150, },
    {
      field: 'sourceStakeholderUrn', headerName: 'Pick-Up Location URN', width: 180,
    },
    { field: 'sourceLocationName', headerName: 'Pick-Up Location Name', width: 180 },
    { field: 'sourceLocationAddress', headerName: 'Pick-Up Location Address', width: 180 },
    { field: 'consignmentStatus', headerName: 'Status', width: 150 },
    {
      field: 'Action', width: 150,
      renderCell: (params) => {
        return (
          <Tooltip title="Pickup Details">
            <IconButton color="primary" onClick={(e) => viewUpdatePickup(e, params.row)}>
              <UpdateIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];


  const onConfirmSave = (e) => {
    handleConfirmClose();
    onSave(e);
  }

  const onSaveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onConfirmCreateDeliveryChallan = (e) => {
    handleConfirmClose2();
    onDeliveryChallan(e);
  }

  const onCreate = (e) => {
    handleConfirmOpen2();
  }

  const onConfirmStartTrip = (e) => {
    handleConfirmClose3();
    onStart(e);
  }

  const onStartDestinationTrip = (e) => {
    // if (!pickupUpdatedDetails?.pickupTareWeight) {
    //   setErrorMessage({ ...errorMessage, pickupTareWeightError: "Please enter tare weight" });
    // }
    // else if (!pickupUpdatedDetails?.pickupGrossWeight) {
    //   setErrorMessage({ ...errorMessage, pickupGrossWeightError: "Please enter gross weight" });
    // }
    // else if (errorMessage?.pickupNetWeightError) {
    // }
    if (!odoMeterReading) {
      setErrorMessage({ ...errorMessage, odometerStartError: "Please enter Odometer Start Reading" })
    }
    else if (pickupUpdatedDetails?.isProperLashing === null) {
      setErrorMessage({ ...errorMessage, isProperLashingError: "Please select proper lashing" });
    }
    else if (pickupUpdatedDetails?.isPayloadWithinCapacity === null) {
      setErrorMessage({ ...errorMessage, isPayloadWithinCapacityError: "Please select payload with capacity limits" });
    }
    else if (pickupUpdatedDetails?.isPayloadLengthExceedLimit === null) {
      setErrorMessage({ ...errorMessage, isPayloadLengthExceedLimitError: "Please select payload length exceeding limits" });
    }
    else if (pickupUpdatedDetails?.isPayloadHeightExceedLimit === null) {
      setErrorMessage({ ...errorMessage, isPayloadHeightExceedLimitError: "Please select payload height exceeding limits" });
    }
    else {
      handleConfirmOpen3();
    }
  }

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT04</p>}
        <Typography variant="h4" gutterBottom>
          Consignment Pick Up/Tracker
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid xs={12} lg={4}>
                    <TextField fullWidth required size='small'
                      error={errorMessage.consignmentNoError}
                      helperText={errorMessage.consignmentNoError}
                      label="Consignment Number"
                      value={consignmentNoDetails?.consignmentNo}
                      name="consignmentNo"
                      onChange={(e) => handleChange(e)}
                      inputProps={{
                        maxLength: 15,
                      }}
                      onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                    />
                    <Button display='flex' alignItems="center" justifyContent="center" style={{ float: "right" }} onClick={(e) => getDetails(e)} >Get Details</Button>
                  </Grid>
                  <Grid container spacing={2} >
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth size='small'
                        label="Consignment Status"
                        value={consignmentdetails?.consignmentStatus || ''}
                        disabled={true} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth size='small' disabled
                        label="Consignment Owner URN"
                        value={consignmentdetails?.consignmentSourceUrn || ''} />
                    </Grid>

                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth size='small' disabled
                        label="Consignment Owner Name"
                        value={consignmentdetails?.consignmentOwnerName || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Consignment Owner Contact" value={consignmentdetails?.consignmentOwnerContactNo || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Schedule Pick-Up Date" value={consignmentdetails?.consignmentScheduleDate && Moment(consignmentdetails?.consignmentScheduleDate).format('DD/MM/YYYY') || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Schedule Delivery Date" type="text" value={consignmentdetails?.scheduleDeliveryTimestamp && Moment(consignmentdetails?.scheduleDeliveryTimestamp).format('DD/MM/YYYY') || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Schedule Consignment Weight(MT)" value={consignmentdetails?.scheduledWeight || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Delivery Location Name" value={consignmentdetails?.consignmentDestinationLocationName || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Delivery Location Address" value={consignmentdetails?.consignmentDestinationLocationAddress || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Type of Inventory" value={consignmentdetails?.materialType || ""} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size="small" label="Type Of Loading(FTL/LTL)" value={consignmentdetails?.typeOfLoading || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size="small" label="Driver Name" value={consignmentdetails?.driverName || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Driver License No." value={consignmentdetails?.driverLicenseNo || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size='small' label="Driver Contact" value={consignmentdetails?.driverContact || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size="small" label="Vehicle Registration" value={consignmentdetails?.vehicleRegNo || ''} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth disabled size="small" label="Delivery Location URN" value={consignmentdetails?.consignmentDestinationStakeholderUrn || ''} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider sx={{
              width: '105%',
              bgcolor: 'black',
              marginTop: '3vh'
            }} mt={2} />
            {
              consignmentsource &&
              <>
                <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                  Grower Details
                </Typography>
                <Box style={{ height: 250, width: '100%' }}>

                  <DataGrid rows={consignmentsource}
                    columns={column}
                    pageSize={10}
                    // getRowId={(row) => row.invoiceNo}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />

                </Box>
                <Grid container mt={2} spacing={1}>
                  {/* <Grid item xs={12} lg={3}>
                    <TextField fullWidth required
                      error={errorMessage.pickupTareWeightError}
                      helperText={errorMessage.pickupTareWeightError}
                      size="small"
                      label='Pickup Tare Weight(in MT)'
                      type="number"
                      disabled={consignmentdetails?.isTripStarted}
                      onFocus={handleNumberFieldFocus}
                      name="pickupTareWeight"
                      value={pickupUpdatedDetails?.pickupTareWeight}
                      onChange={(e) => handleChange(e)}
                      // InputProps={{ maxLength: 6 }}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <TextField fullWidth size="small"
                      label='Pickup Gross Weight(in MT)'
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      required
                      disabled={consignmentdetails?.isTripStarted}
                      error={errorMessage.pickupGrossWeightError}
                      helperText={errorMessage.pickupGrossWeightError}
                      name="pickupGrossWeight"
                      value={pickupUpdatedDetails?.pickupGrossWeight}
                      onChange={(e) => handleChange(e)}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    />
                  </Grid> */}
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small"
                      label='Pickup Net Weight (in MT)'
                      required
                      // error={errorMessage.pickupNetWeightError}
                      // helperText={errorMessage.pickupNetWeightError}
                      type="number"
                      onFocus={handleNumberFieldFocus}
                      name="pickupNetWeight"
                      disabled
                      value={(pickupUpdatedDetails?.pickupNetWeight)?.toFixed(4) || ''} />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <TextField fullWidth size="small" error={errorMessage.odometerStartError}
                      helperText={errorMessage.odometerStartError} label="Enter Odometer Start Reading" type="number" onFocus={handleNumberFieldFocus} name="odometerStart" value={odoMeterReading || ''} onChange={(e) => handleChange(e)} InputProps={{
                        maxLength: 6,
                      }}
                      disabled={consignmentdetails?.isTripStarted}
                      onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6} mt={2}>
                    <FormControl fullWidth required error={errorMessage.isProperLashingError}>
                      <FormLabel id="demo-row-radio-buttons-group-label">Proper Lashing</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isProperLashing === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                        <FormControlLabel name="isProperLashing" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isProperLashing === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                      </RadioGroup>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.isProperLashingError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={6} mt={2}>
                    <FormControl fullWidth required error={errorMessage.isPayloadWithinCapacityError}>
                      <FormLabel id="demo-row-radio-buttons-group-label">Payload With Capacity Limits</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadWithinCapacity === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                        <FormControlLabel name="isPayloadWithinCapacity" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadWithinCapacity === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                      </RadioGroup>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadWithinCapacityError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={6} mt={2}>
                    <FormControl fullWidth required error={errorMessage.isPayloadLengthExceedLimitError}>
                      <FormLabel id="demo-row-radio-buttons-group-label">Payload Length Exceeding Limit</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel name="isPayloadLengthExceedLimit" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadLengthExceedLimit === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                        <FormControlLabel name="isPayloadLengthExceedLimit" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadLengthExceedLimit === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                      </RadioGroup>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadLengthExceedLimitError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={6} mt={2}>
                    <FormControl fullWidth required error={errorMessage.isPayloadHeightExceedLimitError}>
                      <FormLabel id="demo-row-radio-buttons-group-label">Payload Height Exceeding Limit</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                      >
                        <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadHeightExceedLimit === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                        <FormControlLabel name="isPayloadHeightExceedLimit" disabled={consignmentdetails?.isTripStarted ? true : false} checked={pickupUpdatedDetails.isPayloadHeightExceedLimit === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                      </RadioGroup>
                      <FormHelperText sx={{ color: 'red' }}>{errorMessage.isPayloadHeightExceedLimitError}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField fullWidth
                      autoComplete="off"
                      id="outlined-multiline-static"
                      label="Comments (If Any)"
                      multiline
                      rows={4}
                      onChange={onTextValueChange}
                      value={addComment}
                      sx={{ paddingRight: '15%' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                      <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
          </CardContent>
        </Card>
        {consignmentdetails &&
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            {/* {consignmentdetails?.isTripStarted === false ?
              <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSaveButtonClick(e)}>Save</Button>
              : null
            } */}
            {consignmentdetails?.isDeliveryChallanCreated === true || localStorage.getItem('role') == PIT_ROLES.PitScmUser ? null
              : <Button startIcon={<AddIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onCreate(e)}>Create Delivery Challan</Button>}

            {consignmentdetails?.isTripStarted === true ? null :
              <>
                <Button startIcon={<ApproveIcon />} disabled={!consignmentdetails?.isLoadingDone} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onStartDestinationTrip(e)}>Start Trip To Destination</Button>
              </>}

            {consignmentdetails?.delieryChallanNumber !== null ?
              <>
                <Button startIcon={<DownloadIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("download")}>Download</Button>
                <Button startIcon={<PrintIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => getDownloadChallan("print")}>Print</Button>
              </>
              : null
            }

          </Box>
        }
      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmCreateDeliveryChallan} onClose={handleConfirmClose2} action="Create Delivery Challan" />
      <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmStartTrip} onClose={handleConfirmClose3} action="Start Trip To Destination" />

      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={starttrip?.message ? starttrip?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={starttrip?.message ? starttrip?.message : "Error"} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" />
          <DialogActions>
            <Button onClick={handleLogModalClose}>OK</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={saveConsignmentResponse?.message ? saveConsignmentResponse?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen3}>
        <DialogContent>
          <ConfirmPopover hideLink={true} title={createDeliveryChallan?.message ? createDeliveryChallan?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose3}>OK</Button>
        </DialogActions>
      </Dialog>
    </>

  )
}
export default ConsignmentPickUp;